import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/nest_profile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.28.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"variable\":\"--font-nunito\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.28.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Lora\",\"arguments\":[{\"variable\":\"--font-lora\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"lora\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
